@if (data.status === DispatchPaymentStatus.EXCEPTION) {
<h2 mat-dialog-title>Exception Comment</h2>
<mat-dialog-content>
  <form [formGroup]="exceptionForm">
    <textarea
      class="input"
      id="exception"
      formControlName="exception"
      placeholder="Enter Exception Comment"
    ></textarea>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button
    type="button"
    mat-button
    [disabled]="exceptionForm.invalid"
    [mat-dialog-close]="fe.exception.value"
  >
    Confirm
  </button>
</mat-dialog-actions>
} @else {
  <h2 mat-dialog-title>Voucher Number</h2>
  <mat-dialog-content>
    <form [formGroup]="paidForm">
    <textarea
      class="input"
      id="exception"
      formControlName="voucher"
      placeholder="Enter Voucher Number"
    ></textarea>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button
      type="button"
      mat-button
      [disabled]="paidForm.invalid"
      [mat-dialog-close]="fp.voucher.value"
    >
      Confirm
    </button>
  </mat-dialog-actions>
}
